import React from "react";
import IndustriesBannerImage from "../../images/Hero-Banner-Healthcare.jpg";
import SegmentSliderImage1 from "../../images/Providers.jpg";
import SegmentSliderImage2 from "../../images/Payer.jpg";
import SegmentSliderImage3 from "../../images/Patients.jpg"
import SegmentSliderImage4 from "../../images/Pharmaceuticals.jpg";

import IconDeliverExceptionSupport from "../../icons/icon-DeliverException-Support.svg";
import IconMedicalDataProcessing from "../../icons/icon-Medical-Data-Processing.svg";
import IconAutomateCustomerEngagement from "../../icons/icon-Automate-Customer-Engagement.svg";
import IconPatientJourneyEngagement from "../../icons/icon-Patient-Journey-Engagement.svg";

import ImageOutStockDetection from "../../images/Radiology-Augmentation.jpg";
import ImageDeliverPersonalizedExperiences from "../../images/Personalize-Patient-Engagement.jpg";
import ImageMonetizeCrossOpportunities from "../../images/Conversational-Bots.jpg";
import ImageIOTBasedPatientMonitoring from "../../images/IOT-Based-Patient-Monitoring.jpg";

import ImageUseCase1 from "../../images/Automate-Patient-Journey.jpg";
import ImageUseCase2 from "../../images/Connected-Patient-Care1.jpg";
import ImageUseCase3 from "../../images/Health-Intelligence-Analytics.jpg"; 
import ImageUseCase4 from "../../images/Healthcare-IOT.jpg";
import ImageUseCase5 from "../../images/Patient-Visit-Experiences.jpg";
import ImageUseCase6 from "../../images/Robotic-Process-Automations.jpg";

import IconDataAnalytics from "../../icons/icon-retail-data-analytics.svg";
import IconEnterpriseIntegrations from "../../icons/icon-retail-enterprise-integrations.svg";
import IconCloudEnablement from "../../icons/icon-retail-cloud-enablement.svg";
import IconDigitalStrategy from "../../icons/icon-transformation-strategy-roadmap-ps.svg";
import IconDigitalExperiences from "../../icons/icon-retail-digital-experiences.svg";
import IconDigitalTransformation from "../../icons/icon-retail-digital-transformation.svg";

import ImageCSslider1 from "../../images/cs-hc-slider-img-1.jpg";

import ImageBlogImage1 from "../../images/healtcare-blog-img-1.jpg";
import ImageBlogImage2 from "../../images/healtcare-blog-img-2.jpg";

export const mainBannerObj = {
  classes: "industries-banner",
  title: "Retail Industries",
  mediaType: "image",
  mediaSource: IndustriesBannerImage,
  mediaClass: "align-v-center",
  imagetitle: "AI In Healthcare",
  imagealt: "AI In Healthcare",
  bannerItems: [
    {
      subheader:"ANALYTICS",
      header: (<>What is the role of<br />AI in the healthcare<br />industry and its <br/>future?</>),
      content: <>Discover the marvels of modern medical science, AI, and its <br /> role in shaping the future of healthcare.</>,
      buttonText:"Read More",
      link: "/blog/what-is-the-role-of-ai-in-the-healthcare-industry-and-its-future/" 
    }
  ],
  bannerSliderImageItems: [
    {
      image: IndustriesBannerImage,
      imagetitle: "Industries Healthcare",
      imagealt: "Industries Healthcare",
    }
  ]
};

export const pageIntroObj = {
  classes: "section-gap retail-intro",
  title: "Embracing the digital disruption",
  header: (<>Technology and consumer behaviors are reshaping the healthcare <br /> industry to deliver anytime, anywhere, and personalized patient <br />care, now. </>),
  content: (<><p>Like every other industry, digital and data-led revolution is redefining the business models and new opportunities in the 3.6 trillion dollar healthcare industry - not just to improve patient outcomes but also to significantly reduce costs and deliver personalized patient care remotely. Post-pandemic, the entire industry is going to be revolutionized, with a decade worth of innovation, transformation, and automation taking shape in a couple of years. <br/><br/> Rapidops collaborates with healthcare organizations to help them leverage innovations in tech, data, and AI to deliver innovative patient experiences, automate human-driven processes, improve provider and caregiver productivity, launch innovative products and services, and improve patient outcomes at speed, scale, and economics never possible before. </p></>)
};

export const industrySegmentsObj = {
  classes: "section-gap industry-segment",
  title: "HEALTHCARE INDUSTRY",
  header: (<>Industry Segments</>),
  content: (<><p>Rapidops help healthcare providers to accelerate digital health with personalized, efficient and informed care through <br /> operational transformation, patient experience, and digital consulting.</p></>),
  segmentSliderItems: [
    {
      image: SegmentSliderImage1,
      imagetitle: "Providers",
      imagealt: "Providers",
      header: (<>Providers</>),
      content: <>Create leading products, processes, and culture that foster healthcare innovation - we act as the catalyst.</>,
    },
    {
      image: SegmentSliderImage2,
      imagetitle: "Payers",
      imagealt: "Payers",
      header: (<>Payers</>),
      content: <>Deliver greater value and empower customers with innovative healthcare products and operations.</>,
    },
    {
      image: SegmentSliderImage3,
      imagetitle: "Patients",
      imagealt: "Patients",
      header: (<>Patients</>),
      content: <>Transform patient experience, drive administrative efficiency & improve quality of care through AI data analytics.</>,
    },
    {
      image: SegmentSliderImage4,
      imagetitle: "Pharmaceuticals",
      imagealt: "Pharmaceuticals",
      header: (<>Pharmaceuticals</>),
      content: <>Reimagine business models and deliver personalized services to gain a new competitive advantage.</>,
    }
  ]
};

export const threeColSliderObj = {
  classes: "retail-solution",
  header: <>Healthcare Products</>,
  content: <>Unleash the full potential of cloud, data and AI to empower providers, engage patients and <br/> optimize operations.</>,
  items: [
    {
      icon: <IconPatientJourneyEngagement />,
      subHeader: "rapidJOURNEY",
      header: "Patient Journey Engagement",
      content: "Create personalized patient engagement throughout their unique care journey."
    }, {
      icon: <IconMedicalDataProcessing />,
      subHeader: "rapidIOT",
      header: "Medical Data Processing",
      content: "Monitor your clinical devices and generate insights from clinical data."
    }, {
      icon: <IconAutomateCustomerEngagement />,
      subHeader: "Customer Data Platform (CDP)",
      header: "Automate Patient Engagement",
      content: "Automate marketing, sales & customer outreach."
    }, {
      icon: <IconDeliverExceptionSupport />,
      subHeader: "rapidCHAT",
      header: "Deliver Exceptional Support",
      content: "Automate patient support & operational processes with chatbots."
    }
  ]
};

export const industryRetailAIObj = {
  title: "Health AI",
  content: "Use power of data and AI to unlock new growth opportunities",
  tabItems: [
    {
      header: "Radiology Augmentation"
    }, {
      header: "Personalize Patient Engagement"
    }, {
      header: "Conversational Bots"
    }, {
      header: "IOT-based Patient Monitoring"
    }
  ],
  serviceMediaOne: [
    {
      source: ImageOutStockDetection,
      imagetitle: "Radiology Augmentation",
      imagealt: "Radiology Augmentation",
      content: "Automatically identify and localize the x-rays, and CT scans abnormalities with a highly trained deep-learning-based AI imaging engine. Optimize MRI costs and efficiencies with AI image conversion.",
    }
  ],
  serviceMediaTwo: [
    {
      source: ImageDeliverPersonalizedExperiences,
      imagetitle: "Personalized Patient Engagement",
      imagealt: "Personalized Patient Engagement",
      content: "Improve your marketing reach and effectiveness with personalized marketing for each patient and community.",
    }
  ],
  serviceMediaThree: [
    {
      source: ImageMonetizeCrossOpportunities,
      imagetitle: "Conversational Bot",
      imagealt: "Conversational Bot",
      content: "Deliver fast and conversational patient experience for onboarding, engagement, and service across multiple channels with intelligent chatbots.",
    },
  ],
  serviceMediaFour: [
    {
      source: ImageIOTBasedPatientMonitoring,
      imagetitle: "IOT Based Patient Monitoring",
      imagealt: "IOT Based Patient Monitoring",
      content: "Track orthopedic and physical therapy patient’s exercise routines and compliance with sensors and machine learning.",
    },
  ]
};


export const useCaseObj = {
  classes: "reatail-usecase",
  header: (<>Healthcare Solutions</>),
  content: (<><p>Enabling healthcare providers to thrive in the digital age</p></>),
  useCaseItems: [
    {
      image: ImageUseCase1,
      imagetitle: "Automate Patient Journey",
      imagealt: "Automate Patient Journey",
      title: (<>Automate Patient Journey</>),
      content: <>Enable personalized and automated patient engagement at each stage of their unique health journey.</>,
    },
    {
      image: ImageUseCase2,
      imagetitle: "Connected Patient Care",
      imagealt: "Connected Patient Care",
      title: (<>Connected Patient Care</>),
      content: <>Continue to deliver care and guidance to your patients for their unique conditions anytime and anywhere.</>,
    },
    {
      image: ImageUseCase3,
      imagetitle: "Health Intelligence & Analytics",
      imagealt: "Health Intelligence & Analytics",
      title: (<>Health Intelligence & Analytics</>),
      content: <>Make better decisions, improve provider efficiencies, and launch data-driven experiences, products, and services.</>,
    },
    {
      image: ImageUseCase4,
      imagetitle: "Healthcare IOT",
      imagealt: "Healthcare IOT",
      title: (<>Healthcare IOT</>),
      content: <>Proactively monitor and analyze data from clinical and patient devices and assets with a centralized IoT analytics solution.</>,
    },
    {
      image: ImageUseCase5,
      imagetitle: "Patient Visit Experience",
      imagealt: "Patient Visit Experience",
      title: (<>Patient Visit Experiences</>),
      content: <>Automate paper-based processes, reduce waiting time, and deliver seamless appointment experiences.</>,
    },
    {
      image: ImageUseCase6,
      imagetitle: "Robotic Process Automation",
      imagealt: "Robotic Process Automation",
      title: (<>Robotic Process Automation</>),
      content: <>Eliminate manual steps and errors to improve costs, productivity, and operational efficiencies with RPA.</>,
    }
  ]
};

export const gridlayoutObj = {
  classes: "two-row-three-col-grid",
  header: "Services",
  subHeader: "Our end-to-end digital services to help you lead the digital disruption.",
  gridItems: [
    {
      icon: <IconDataAnalytics />,
      header: "Data Analytics",
      content: "Deliver rich data-driven insights and experiences across products and customers with analytics and AI"
    },
    {
      icon: <IconEnterpriseIntegrations />,
      header: "Enterprise Integrations",
      content: "Integrate and orchestrate the silo’ed internal and external systems to reduce costs and create digital sales channels"
    },
    {
      icon: <IconCloudEnablement />,
      header: "Cloud Enablement",
      content: "Create automated and cost-effective technology infrastructure on public (GCP, Azure, AWS) or private clouds"
    },
    {
      icon: <IconDigitalStrategy />,
      header: "Digital Strategy",
      content: "Discover and monetize digital opportunities with a proven strategy and battle-tested approach"
    },
    {
      icon: <IconDigitalExperiences />,
      header: "Digital Experiences",
      content: "Launch stunning and personalized shopping, service, and engagement experiences for all customers "
    },
    {
      icon: <IconDigitalTransformation />,
      header: "Digital Transformation",
      content: "Beat the competition and lead the market by transforming your business with technology, design, and data"
    }
  ]
};

export const CSSliderObj = {
  classes: "section-gap cs-sldier",
  csSliderItems: [
    {
      image: ImageCSslider1,
      imagetitle: "Patient experience app",
      imagealt: "Patient experience app",
      category: "Healthcare",
      header: (<>Automated Patient Engagement</>),
      content: <>Delivering personalized  and automated patient care experience.</>,
      link: "/work/personalized-automated-patient-experience/",
    }
  ]
};


export const digitalThinkingobj = {
  classes: "digital-thinking",
  header: (<>Digital Thinking</>),
  content: (<><p>Our experts discuss strategies for navigating the healthcare landscape</p></>),
  blogGridItems: [
    { 
      width: "one-third",
      backgroundColor: "#F8F8F8",
      image: "",
      color: "black",
      category: "Strategy",
      categoryColor: "#999999",
      title: (<>Develop a winning strategy for successful product launch</>),
      link: "/blog/product-strategy-guide/"
    },
    { 
      width: "one-third",
      backgroundColor: "#000000",
      image: ImageBlogImage1,
      imagealt: "Healthcare Technology Advancements Examples",
      imagetitle: "Seven exceptional healthcare technology advancements of the last decade",
      color: "white",
      category: "Analytics",
      categoryColor: "#fff",
      title: (<>Seven exceptional healthcare technology advancements of the last decade</>),
      link: "/blog/healthcare-technology-advancements/"
    },
    { 
      width: "one-third green-bg",
      backgroundColor: "#00D664",
      image: "",
      color: "black",
      category: "Analytics",
      categoryColor: "#333",
      title: (<>Developing a successful digital transformation roadmap for your business</>),
      link: "/blog/digital-transformation-roadmap/"
    },
    { 
      width: "half with-img",
      backgroundColor: "transparent",
      image: ImageBlogImage2,
      imagealt: "Iot in healthcare",
      imagetitle: "IoT is transforming the Healthcare frontier!",
      color: "white",
      category: "IoT",
      categoryColor: "#fff",
      title: (<>IoT is transforming the Healthcare frontier!</>),
      link: "/blog/iot-is-transforming-the-healthcare-frontier/"
    },
    { 
      width: "half without-img",
      backgroundColor: "linear-gradient(0deg, #F8F8F8, #F8F8F8), #F8F8F8",
      image: "",
      color: "black",
      category: "Ideas",
      categoryColor: "#999999",
      title: (<>How digital transformation is beneficial to keep the Covid-19 pandemic in check?</>),
      link: "/blog/how-digital-transformation-is-beneficial-to-keep-the-covid-19-pandemic-in-check/"
    },
    
  ],
  header1: (<>Proven results in weeks, not years.</>),
  content1: (<><p>Rapidops can transform your vision into measurable success in days and weeks with the proven approach and expertise for digital transformation.</p></>),
};